export const soldProductsV2 = {
	tabTitle: "Produtos Vendidos",
	header: {
		title: "Produtos Vendidos",
		subtitle:
			"Acompanhe os produtos vendidos e visualize suas vendas de forma detalhada.",
		exportButton: "Exportar",
		exportLoading: "Exportando...",
		exportNotification:
			"o relatório será gerado e assim que estiver pronto será enviado para o seu e-mail ({{email}})",
	},
	inlineFilters: {
		filterByProduct: "Filtrar por produto",
		noProductFound: "Nenhum produto encontrado",
		filterByCategory: "Filtrar por categoria do produto",
		noCategoryFound: "Nenhuma categoria encontrada",
		filtersButton: "Filtros",
	},
	filterModal: {
		title: "Filtros",
		filterOptionsLabel: "Opções de filtros",
		filteredBy: "Filtrado por",
		clearSelection: "Limpar seleção",
		cancel: "Cancelar",
		clearFilters: "Limpar filtros",
		apply: "Aplicar",
		nav: {
			dateOrPeriod: "Data ou período",
			product: "Produto",
			barsAndSectors: "Bares e setores",
			operation: "Operação",
			transactions: "Transações",
		},
		period: {
			today: "Hoje",
			yesterday: "Ontem",
			last30Days: "Últimos 30 dias",
			customPeriod: "Período personalizado",
		},
		periodLabels: {
			today: "hoje",
			yesterday: "ontem",
			last_30_days: "últimos 30 dias",
			custom: "período personalizado",
		},
		productSection: {
			productLabel: "Produto",
			productStatusLabel: "Status do produto",
			productTypeLabel: "Tipo de produto",
			categoryLabel: "Categoria",
			filterByProduct: "Filtrar por produto",
			filterByType: "Filtrar por tipo",
			filterByCategory: "Filtrar por categoria",
			noProductFound: "Nenhum produto encontrado",
			noTypeFound: "Nenhum tipo encontrado",
			noCategoryFound: "Nenhuma categoria encontrada",
		},
		status: {
			active: "Ativo",
			inactive: "Inativo",
		},
		barsAndSectorsSection: {
			barLabel: "Bar",
			sectorLabel: "Setor",
			filterByBar: "Filtrar por bar",
			filterBySector: "Filtrar por setor",
			noBarFound: "Nenhum bar encontrado",
			noSectorFound: "Nenhum setor encontrado",
		},
		operationSection: {
			operationTypeLabel: "Tipo de operação",
		},
		operationTypes: {
			Table: "Operação mesa",
			ZigTag: "Operação cashless",
		},
		transactionsSection: {
			transactionTypeLabel: "Tipo de transação",
			filterByTransaction: "Filtrar por transação",
			noTypeFound: "Nenhum tipo encontrado",
		},
		sources: {
			balcony: "Balcão",
			cashless: "Cashless",
			dash: "Dashboard",
			delivery: "Delivery",
			ficha: "Ficha",
			grabngo: "Grab n Go",
			onlineBill: "Comanda Online",
			zigQrcode: "QR Code Zig",
			onlineFicha: "Ficha Digital",
			table: "Mesa",
			hce: "Cartão digital",
		},
		activeFilterLabels: {
			period: "PERÍODO",
			status: "STATUS",
			operation: "OPERAÇÃO",
			product: "PRODUTO",
			category: "CATEGORIA",
			bar: "BAR",
			sector: "SETOR",
			transaction: "TRANSAÇÃO",
		},
	},
	table: {
		sku: "SKU",
		name: "Nome",
		unitQty: "Qtd. Unit.",
		unitValue: "Valor Unit.",
		subtotal: "SUBTOTAL",
		discounts: "Descontos",
		totalValue: "VALOR TOTAL",
		subtotalTooltip: "Valor total sem contabilizar os descontos.",
		totalValueTooltip: "Valor total com os descontos aplicados.",
		mountable: "(montável)",
		total: "Total",
		values: "{{count}} valores",
		variationUnitQty: "Qtd Unit",
		variationUnitValue: "Valor Unit",
		variationSubtotal: "Subtotal",
		variationDiscounts: "Descontos",
		variationTotalValue: "Valor Total",
	},
	mountableModal: {
		name: "Nome",
		section: "Seção",
		quantity: "Quantidade",
	},
};
